import styled from 'styled-components' 
export default styled.div`

@media (max-width: 768px) {
    .schedule-heading{
        font-size:7px;
    }
` 